module.exports = __webpack_public_path__ + "img/icon-warning_hover.40a77396.svg";